import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { FaRegCalendarAlt } from 'react-icons/fa';
import TalktoExpert from '../Pages/Products/TalktoExpert';
import BookaDemo from '../Pages/Products/BookaDemo';


const EXCLUDED_PATHS = ['/gallery', '/businesspartner'];

const DemoPopup = () => {
  const location = useLocation();
  
  const [showTrigger, setShowTrigger] = useState(false);
  
  const [showPopup, setShowPopup] = useState(false);

  const path = (location.pathname || '').toLowerCase();
  const isExcluded = EXCLUDED_PATHS.some(p => path.includes(p));

  useEffect(() => {
    setShowPopup(false);
    setShowTrigger(false);
    if (isExcluded) return;
    
    const timer = setTimeout(() => setShowTrigger(true), 20000);
    return () => clearTimeout(timer);
  }, [location.pathname, isExcluded]);

  if (isExcluded) {
    return null;
  }

  return (
    <>
    
      {showTrigger && !showPopup && (
        <button
          className="demoTriggerBtn"
          onClick={() => setShowPopup(true)}
          aria-label="Book a demo"
        >
          <span className="demoTriggerLabel">Book a Demo</span>
          {/* <FaRegCalendarAlt /> */}
        </button>
      )}

    
      {showPopup && (
        <div className="ads-popup-overlay">
          <div className="ads-popup-box demoPopupBox">
            <button className="ads-close-btn" onClick={() => setShowPopup(false)}>✖</button>
            <section className='HoldonSec demoPopupSec'>
              <div className='textBlack tbTitle textCenter titlemBtm'>
                <h2><span>Hold On</span></h2>
                <p>did you try our demo ?</p>
              </div>
              <div className='honInROw'>
                <Row>
                  <Col md='6' className='honCol honColL'>
                    <div className='HoFromCont'>
                      <h4>Talk To An Expert</h4>
                      <TalktoExpert/>
                    </div>
                  </Col>
                  <Col md='6' className='honCol honColR'>
                    <div className='HoCalen'>
                      <BookaDemo/>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default DemoPopup;
